import builder from '../builder';
import NavigationRightCircle from '../../streamline-icons/bold/navigation-right-circle-1_1.svg';

export default builder('IconNavigationRightCircleBold', NavigationRightCircle);
